// Dependencies
import * as zod from 'zod';

export const studentValidationSchema = zod.object({
  student: zod.object({
    name: zod.string().trim().min(1, 'O nome é obrigatório.'),
    email: zod.string().trim().email('O email é obrigatório.'),
    whatsapp: zod
      .string()
      .trim()
      .min(1, 'O whatsapp é obrigatório.')
      .refine(
        whatsapp => whatsapp.replace(/\D/g, '').length === 11,
        'O whatsapp deve ter 11 dígitos',
      ),
  }),
});

export type StudentFormData = zod.infer<typeof studentValidationSchema>;
